//@ helpers
const actionTypes = require('constants/contactCenter/actionTypes');
// @ utilities
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
//@ actions
const signaturePatternActions = require('actions/signaturePattern');

const reset = () => ({
    type: actionTypes.CANCEL_CREDIT_CARD_RENEWAL_RESET
});

const setVisibleStep = (data) => ({
    type: actionTypes.CANCEL_CREDIT_CARD_RENEWAL_SET_VISIBLE_STEP,
    payload: {
        data
    }
});

const validateStep = (data) => ({
    type: actionTypes.CANCEL_CREDIT_CARD_RENEWAL_VALIDATE_STEP,
    payload: {
        data
    }
});

const setWillCancel = willCancel => ({
    type: actionTypes.CANCEL_CREDIT_CARD_RENEWAL_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const getRenewalDetailsRequest = () => ({
    type: actionTypes.CANCEL_CREDIT_CARD_RENEWAL_DETAILS_REQUEST
});

const getRenewalDetailsSuccess = (data) => ({
    type: actionTypes.CANCEL_CREDIT_CARD_RENEWAL_DETAILS_SUCCESS,
    payload: {
        data
    }
});

const getRenewalDetailsFailure = (error) => ({
    type: actionTypes.CANCEL_CREDIT_CARD_RENEWAL_DETAILS_FAILURE,
    payload: {
        error
    }
});

const cancelRenewalRequest = () => ({
    type: actionTypes.CANCEL_CREDIT_CARD_RENEWAL_REQUEST
});

const cancelRenewalSuccess = (data) => ({
    type: actionTypes.CANCEL_CREDIT_CARD_RENEWAL_SUCCESS,
    payload: {
        data
    }
});

const cancelRenewalFailure = (error) => ({
    type: actionTypes.CANCEL_CREDIT_CARD_RENEWAL_FAILURE,
    payload: {
        error
    }
});

const getCreditCardRenewalDetails = (cardId) => (dispatch, getState) => {
    const immCard = getState().cards.getIn(['byId', cardId]);
    const number = immCard.get('number').replace(/\s+/g, '');
    const product = immCard.getIn(['contract', 'product']);
    const contractNumber = immCard.getIn(['contract', 'number']);

    const requestData = {
        pan: number,
        product: product,
        contractNumber: contractNumber
    };

    dispatch(getRenewalDetailsRequest());

    APIGet(dispatch, apiURLBuilder.getURL('creditCardRenewalDetails', requestData))
        .then( response => dispatch(getRenewalDetailsSuccess( response )))
        .catch( error => dispatch(getRenewalDetailsFailure( error )));
}

const cancelRenewal = (cardId) => (dispatch, getState) => {
    const callback = (dispatch, getState, token) => {
        const immCard = getState().cards.getIn(['byId', cardId]);
        const pan = immCard.get('number').replace(/ /g,'');
        const contractNumber = immCard.getIn(['contract', 'number']);
        const product = immCard.getIn(['contract', 'product']);
        const requestData = {
                query: {
                    contractNumber: contractNumber,
                    pan: pan,
                    product: product,
                    token: token
                }
            };
        dispatch(cancelRenewalRequest());
        return APIPost({
            dispatch,
            endpoint: 'cancelCreditCardRenewalConfirm',
            params: requestData
        })
        .then((response) => dispatch(cancelRenewalSuccess(response)))
        .catch((response) => {
            if (!!response.error) {
                dispatch(cancelRenewalFailure(response.error));
            } else {
                throw response;
            }
        });
    };

    signaturePatternActions.validateAndExecute(dispatch, getState, callback);

}


module.exports = {
    reset,
    setWillCancel,
    setVisibleStep,
    validateStep,
    cancelRenewal,
    getCreditCardRenewalDetails
}
